import api from './api';

/**
 * Fetch all active carousel items (public endpoint)
 * Returns only active carousel items ordered by display order
 */
export const fetchCarouselItems = async () => {
  try {
    const response = await api.get('/carousel');
    return response.data;
  } catch (error) {
    console.error('Error fetching carousel items:', error);
    throw error;
  }
};
